export const LAYER_TITLE = "Vues";
export const SEARCH_TEXT_BUTTON = "Rechercher";
export const SEARCH_TEXT_LOADING = "Recherche...";
export const CONFIRM_ADDRESS_TITLE = "Confirmation d'adresse";
export const BUTTON_TEXT_CONFIRM = "Confirmer";
export const BUTTON_TEXT_CANCEL = "Annuler";
export const RESULT_ADDRESS_TITLE = "Résultats pour";
export const AFFICHER_COUCHE = "Afficher les filtres";
export const BUTTON_TEXT_OK = "Ok";
export const ERROR_TEXT_NETWORK = "Une erreur réseau est survenue";
export const ERROR_TEXT_NO_RESULT = "Aucun résultat";
export const AUTOCOMPLETE_PLACEHOLDER = "Adresse ou numéro de téléphone";
export const ERROR_GEOLOCATION_LABEL = "Impossible de vous géolocaliser";
export const SHOW_RESULT_LABEL = "Accéder aux offres disponibles";
export const ASK_FOR_QUOTE_LABEL = "Contactez un commercial";
export const ELIGIBILITY_FIBRE_DEDIEE_TITLE = "Offre Fibre Dédiée Entreprise";
export const ELIGIBILITY_MUTUALISEE_DEDIEE_TITLE = "Offre Fibre Mutualisée";
export const ELIGIBILITY_CUIVRE_TITLE = "Offre Cuivre";
export const ELIGIBILITY_MOBILE_TITLE = "Offre Radios";
export const NO_NUM_FOUND =
	"Nous n'avons pas pu trouver votre numéro de téléphone";
export const MD_EXAMPLE = "# Titre\n\nparagraph";
export const VALIDE_FORMULAIRE_CONTACT = "Demande de devis";
export const TITRE_FORMULAIRE_CONTACT = "Contactez-nous";
export const BUTTON_TEXT_COMMANDER = "Commandez en ligne";
export const BUTTON_TEXT_DEVIS = "Demandez un devis en ligne";
